import { Box, Typography } from '@mui/material';
import COLORS from '@/resources/style/Themes';

interface NotificationBubbleProps {
  count: number;
  size?: number;
}

/**
 * A circular notification bubble that displays a count.
 * Used to show the number of pending items (e.g., join requests).
 */
export const NotificationBubble = ({
  count,
  size = 20,
}: NotificationBubbleProps) => {
  if (count <= 0) return null;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: COLORS.RED,
        color: COLORS.WHITE,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        zIndex: 1,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: 'bold',
          lineHeight: 1,
          textAlign: 'center',
        }}
      >
        {count}
      </Typography>
    </Box>
  );
};

export default NotificationBubble;
